import React from 'react';

import { useContext } from 'react';
import AuthContext from '../context/auth-context'
import * as userpermission from "../utils/PermissionCheck.js"

import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import { Nav, NavDropdown } from "react-bootstrap";
import './navbar.scss';

export default function SiCmsNavbar() {

  const authCtx = useContext(AuthContext);
  const username = localStorage.getItem("username");

  return (
    <Container fluid className='px-0'>
      <Navbar sticky="top" bg="dark" variant="dark" expand="lg" className="py-0">

        <Container fluid>
          <Navbar.Brand href="/" className="brand-img">
            <img
              src="/img/logo_startupitalia.png"
              // width="30"
              height="24"
              className="d-inline-block align-top"
              alt="Startupitalia logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ fontSize: "smaller" }} />
          <Navbar.Collapse className="justify-content-end">
            {
              authCtx.isLogged ? (
                <Nav>
                  <Navbar.Text className="mx-3 d-inline-flex align-items-center">
                    Signed in as: <i>{username}</i>
                  </Navbar.Text>
                  <NavDropdown
                    menuVariant="dark"
                    title="Homepages"
                    className='ms-3 d-lg-none'
                    id="offcanvasNavbarDropdown"
                  >
                    <NavDropdown.Item href="/homepages/">
                      All Pages
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/maps/">
                      Maps
                    </NavDropdown.Item>
                  </NavDropdown>
                  {/* <NavDropdown
                    menuVariant="dark"
                    title="V Homepage"
                    className='ms-3 d-lg-none'
                    id="offcanvasNavbarDropdown"
                  >
                    <NavDropdown.Item href="/homepage/life/">
                      Life
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/smartmoney/">
                      Smart Money
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/thefoodmakers/">
                      The Food Makers
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/valoreresponsabile/">
                      Valore Responsabile
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown
                    menuVariant="dark"
                    title="Homepage"
                    className='ms-3 d-lg-none'
                    id="offcanvasNavbarDropdown"
                  >
                    <NavDropdown.Item href="/homepage/economy/">
                      Economy
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/education/">
                      Education
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/impact/">
                      Impact
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/lifestyle/">
                      Lifestyle
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/startup/">
                      Startup
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/homepage/tech/">
                      Tech
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/homepage/tech/">
                      Live TV
                    </NavDropdown.Item>
                  </NavDropdown> */}

                  <NavDropdown
                    menuVariant="dark"
                    title="Articles"
                    className='ms-3 d-lg-none'
                    id="offcanvasNavbarDropdown"
                  >
                    <NavDropdown.Item href="/articles">
                      All Articles
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown
                    menuVariant="dark"
                    title="Live"
                    className='ms-3 d-lg-none'
                    id="offcanvasNavbarDropdown"
                  >
                    <NavDropdown.Item href="/liveview">
                      All Lives/Videos
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/livetags">
                      Tags
                    </NavDropdown.Item>
                  </NavDropdown>
                  {userpermission.PermissionCheck('view_user', [...authCtx.permissionList]) &&
                    <NavDropdown
                      menuVariant="dark"
                      title="All Permissions"
                      className='ms-3 d-lg-none'
                      id="offcanvasNavbarDropdown"
                    >
                      <NavDropdown.Item href="/userpermissions">
                        All Permissions
                      </NavDropdown.Item>
                    </NavDropdown>
                  }
                  {/* <Navbar.Text className="ms-3">
                    <button className="btn btn-light button-logout" type="button" onClick={Logout}>
                      Logout
                    </button>
                  </Navbar.Text> */}
                  <Nav.Link href="/logout" className="ms-3 d-lg-none">
                    Logout
                  </Nav.Link>
                </Nav>
              ) : (<Nav>
                <Nav.Link href="/login" className="ms-3 d-lg-none">
                  Login
                </Nav.Link>
              </Nav>)
            }
          </Navbar.Collapse>
        </Container>

      </Navbar>
    </Container>
  );
}
